module.exports = __webpack_public_path__ + "img/iconPasswordSet.5fe3ae02.svg";